<script>
export default {
	name: 'AudioIcon',
	emits: ['toggleSound'],
	computed: {
		isAudioOn() {
			return this.$store.state.isAudioOn
		},
		isRouteIntroduction() {
			return this.$route?.name === 'introduction'
		},
		iconColor() {
			return this.isRouteIntroduction ? 'black' : 'white'
		},
		iconBackgroundColor() {
			return this.isRouteIntroduction
				? 'rgba(255,255,255, 0.7)'
				: 'rgba(0,0,0, 0.4)'
		}
	}
}
</script>

<template>
	<div
		class="audio-icon"
		:style="{
			borderColor: iconColor,
			backgroundColor: iconBackgroundColor
		}"
		@click="$emit('toggleSound')"
	>
		<svg
			v-if="isAudioOn"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.602539 14.0342V6.43761H2.40767L7.14613 2V17.9453L2.40767 14.0342H0.602539Z"
				:stroke="iconColor"
			/>
			<path
				d="M9.6272 5.9873C11.0357 6.63923 12.0349 8.27922 12.0349 10.1993C12.0349 12.1193 11.0357 13.7593 9.6272 14.4112"
				:stroke="iconColor"
			/>
			<path
				d="M11.9597 2.2832C14.566 3.57703 16.3973 6.63332 16.3973 10.1976C16.3973 13.7618 14.566 16.8181 11.9597 18.1119"
				:stroke="iconColor"
			/>
		</svg>
		<svg
			v-else
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0.602539 14.0342V6.43761H2.40767L7.14613 2V17.9453L2.40767 14.0342H0.602539Z"
				:stroke="iconColor"
			/>
		</svg>
	</div>
</template>

<style lang="sass">
.audio-icon
  display: flex
  justify-items: center
  align-items: center
  cursor: pointer
  border: 1px solid #2D2D2D
  border-radius: 50%
  padding: 15px
</style>
